import {redirectToOldPracticeDashboard} from "@/util/OldDashboardLink.js";
import store from "src/store";

export function logout() {
    console.log("LogoutProcess::Logging Out")
    // we need to clear vuex current user
    store.commit('currentUser/clearUser')
    // we need to clear vuex pinned user
    store.commit('pinnedUser/clearUser')
    // we need to clear user's bearer token
    store.commit('currentUser/clearToken')
    //redirect to logout
    redirectToOldPracticeDashboard("../home/healthtrac/login.asp?logout=Y")
}